import { render, staticRenderFns } from "./downloadV2.vue?vue&type=template&id=c3a1104c&scoped=true&"
import script from "./downloadV2.vue?vue&type=script&lang=js&"
export * from "./downloadV2.vue?vue&type=script&lang=js&"
import style0 from "./downloadV2.vue?vue&type=style&index=0&id=c3a1104c&prod&lang=css&"
import style1 from "./downloadV2.vue?vue&type=style&index=1&id=c3a1104c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a1104c",
  null
  
)

export default component.exports